










import Vue from 'vue'
import store from './store'
import Instructions from './components/Instructions.vue'
import P5Block from './components/P5Block.vue'
import FooterBar from './components/FooterBar.vue'
import { anonymousSignOn, addResultRecords } from './api/firebase'

export default Vue.extend({
  store,
  name: 'app',
  components: {
    Instructions,
    P5Block,
    FooterBar
  },
  props: {
    blocks: {
      type: String,
      default: "Anger,Fear,Joy,Sadness,Analytical,Confident,Tentative,Negative,Positive"
    },
    instructions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dataToSave(): Array<any> {
      return this.$store.state.objectStorage
    },
    userId(): number {
      return this.$store.state.userId
    },
    blocksArray(): any {
      return this.blocks ? this.blocks.split(",") : null
    }
  },
  data () {
    return {
      autosave: false
    }
  },
  mounted() {
    anonymousSignOn().then((uid) => {
      this.$store.commit('setUser', uid)
      this.autosave = true
    })
  },
  watch: {
    dataToSave: {
      handler () {
        this.$store.commit('saveState', false)
        if(this.autosave == true && this.dataToSave){
          addResultRecords(this.dataToSave, this.userId, (value: any) => {
            this.$store.commit('saveState', value)
          })
        }
      },
      deep: true
    }
  }
})
